module.exports = __webpack_public_path__ + "media/images/users/sumaho-b35ebb51510d07f042001f988abd9cae.png";